import Android1 from './images/Android_1_150_br-pt.png';
import Android2 from './images/Android_Dodaj_150_br-pt.png';
import Ios1 from './images/IOS_1_150_br-pt.png';
import Ios2 from './images/IOS_Dodaj_150_br-pt.png';
import Last from './images/ios_android_3.png';

import VolumeUp from './images/dailyTutorial/volume-up.svg';
import HandsUp from './images/dailyTutorial/hand-up.svg';
import VolumeUpBlank from './images/dailyTutorial/volume-up-blank.svg';
import TranslationBlank from './images/dailyTutorial/icon-translate-blank.svg';
import HintBlank from './images/dailyTutorial/idea-blank.svg';
import InfoBlank from './images/dailyTutorial/information-blank.svg';
import GreenCircle from './images/dailyTutorial/green-circle.svg';
import YellowCircle from './images/dailyTutorial/yelow-circle.png';
import Microphone from './images/dailyTutorial/icon-microphone.svg';
import ScreenOne from './images/dailyTutorial/samouczek_czat_1.png';
import ScreenTwo from './images/dailyTutorial/samouczek_czat_2.png';
import ScreenThree from './images/dailyTutorial/samouczek_czat_3.png';
import ScreenFour from './images/dailyTutorial/samouczek_czat_4.png';
import Tutorial from './images/dailyTutorial/samouczek-fiolet.svg';

import Micro from './images/wordTrainerTutorial/icon-microphone.png';
import Voice from './images/wordTrainerTutorial/volume-up.svg';
import Person from './images/wordTrainerTutorial/user.svg';

export default {
	passwordRestart: {
		title: 'Redefinir senha',
		password: 'Senha',
		repeatPassword: 'Repita a senha',
		restartPawssord: 'Redefinir senha',
	},

	paywall: {
		title: 'Escolha um plano para continuar aprendendo',
		buy: 'Comprar',
		savePayment: 'Pagamentos seguros processados por',
		skip: 'Pular',
		pickPlan: 'Escolha um plano',
		endPlanFirstPart: 'Seu acesso expirará em',
		endPlanSecondPart: 'dias.',
		endPlanAditionalPart: 'dia.',
		paymentTitle: 'Resumo',
		product: 'Produto:',
		plan: 'Pacote SynthiAi',
		forLong: 'Acesso por',
		data: 'dados:',
		nameAndSurname: 'Nome completo:',
		paymentForm: 'Método de pagamento:',
		toPay: 'A pagar hoje:',
		accept: 'Aceitar',
		rules: 'termos',
		payingAccept: 'Ao pagar você aceita',
		paymentRules: '"Termos de pagamento PayU"',
		buyAndPay: 'COMPRAR E PAGAR',
	},
	paymentStatus: {
		veryfication: 'O pagamento ainda está sendo processado...',
		title: 'Pagamento concluído',
		success: 'com sucesso!',
		failure: 'falhou!',
		subtitle: 'Você será redirecionado para a página de login em breve.',
		textInfo: `Seu pagamento foi processado com sucesso. Agora você pode configurar sua senha acessando nossa página de registro. Em alguns minutos, você receberá um e-mail com um link que permitirá que você defina sua senha.

Por favor, verifique sua caixa de entrada, incluindo a pasta de spam. Para facilitar a busca, digite "synthiai" no campo de pesquisa. Se você tiver problemas, entre em contato conosco através de: contact@synthiaiapp.com`,
		login: 'Ir para login',
	},
	register: {
		steps: {
			register: 'Cadastro',
			package: 'Pacote',
			summarize: 'Resumo',
			step: 'Passo ',
		},
		stepOne: {
			password: 'Senha',
			errorGoogle: 'Conecte-se com seu e-mail.',
			title: 'Cadastro',
			nameAndSurname: 'Nome completo',
			placeholderNameAndSurname: 'ex. Adam Smith',
			email: 'E-mail',
			placeholderEmail: 'ex. exemplo@synthiaiapp.com',
			password: 'Senha',
			start: 'CRIAR CONTA',
			subtitle:
				'A senha deve ter pelo menos 8 caracteres e conter letras maiúsculas, minúsculas e números.',
			passwordError1: 'A senha deve ter pelo menos 8 caracteres.',
			passwordError2: 'A senha deve conter pelo menos 1 letra maiúscula.',
			passwordError3: 'A senha deve conter pelo menos 1 letra minúscula.',
			passwordError4: 'A senha deve conter pelo menos 1 número.',
			passwordError5: 'As senhas devem ser idênticas.',
		},
		stepTwo: {
			title: 'Escolha seu plano',
			month: 'Mês',
			months: 'Meses',
			months2: 'Meses',
			value: '€/Mês',
			pick: 'escolher',
			nowPay: 'Pagar agora',
			saveOne: 'Economize',
			buy: 'Comprar',
			savePayment: 'Pagamentos seguros processados por',
		},
		stepThree: {
			title: 'Resumo',
			product: 'Produto:',
			plan: 'Pacote Synthi Ai',
			forLong: 'Acesso por',
			data: 'Dados:',
			nameAndSurname: 'Nome completo:',
			paymentForm: 'Método de pagamento:',
			toPay: 'A pagar hoje:',
			accept: 'Aceitar',
			rules: 'Regras',
			payingAccept: 'Ao pagar você aceita',
			paymentRules: '"Políticas de pagamento PayU"',
			buyAndPay: 'COMPRAR E PAGAR',
		},
	},
	firstLogin: {
		createPasswordForAcoount: 'Crie uma senha para sua conta',
		typeEmail: 'Digite seu e-mail',
		useSameEmail: 'Use o mesmo e-mail fornecido na compra',
		typePassword: 'Digite a senha',
		confirmPassword: 'Confirme a senha',
		createPassword: 'Criar senha',
		errorLogin: 'Verifique se o e-mail ou a senha estão corretos',
		createdPassword: 'Já criou uma senha?',
		clickToLogin: 'Clique aqui para fazer login',
	},
	login: {
		dontHavePassword: 'Ainda não tem uma senha?',
		getPassword: 'Clique aqui para obter acesso',
		title: 'Login',
		email: 'E-mail',
		password: 'Senha',
		textSub: 'Esqueceu a senha? Redefina-a',
		restart: 'aqui',
		restartPasswordText:
			'Digite seu e-mail para redefinir a senha. A senha será enviada para o seu e-mail.',
		placeholder: 'Digite seu e-mail...',
		resetPassword: 'Redefinir senha',
		buttonText: 'Login',
		errorLogin: 'Verifique se o e-mail ou senha estão corretos',
		passwordResterted: 'Sua senha foi redefinida, verifique seus e-mails.',
		passwordError: 'Infelizmente, não encontramos o seu e-mail.',
		mobileAppBannerText: 'Descubra nosso aplicativo!',
	},
	navBar: {
		home: 'Início',
		learn: 'Aprender',
		profile: 'Perfil',
	},
	home: {
		hello: 'Olá',
		question: 'Sobre o que você gostaria de falar hoje?',
		answer: 'Comece uma conversa',
		forYou: 'Recomendado para você',
		popularNow: 'Popular agora',
		doYouKnow: 'Você sabia que...?',
		funFact: 'Fato do dia',
		new: 'Novo',
		check: 'Verifique',
		yourFavorite: 'Seus favoritos',
		newTitle: 'Treinador de palavras',
		newSubtitle: 'Pratique a pronúncia das palavras',
		talkWith: 'Converse sobre qualquer assunto com',
		photoConversation: {
			photoConversationMode: 'Modo Conversa com Foto',
			goToChatTakeAPhoto:
				'Acesse o chat, tire uma foto ou escolha da galeria e converse sobre ela.',
			check: 'Verificar',
			new: 'Novo',
		},
	},
	learn: {
		wordTrainer: {
			title: 'Treinador de palavras',
			subtitle: 'Pratique a pronúncia das palavras',
			new: 'Novo',
		},
		flashcardV2: {
			new: 'Novo',
			sport: 'Esportes',
			continue: 'continuar',
			nice: 'Maravilhoso!',
			congratulation: 'Parabéns!',
			category: 'Categoria',
			textAfterCategory: 'não tem segredos para você!',
			pickNewCategory: 'Escolha uma nova categoria',
			showResult: 'Mostrar solução',
			createWordWithLetters: 'Crie uma palavra a partir das letras misturadas',
			know: 'Sei',
			dontKnow: 'Não sei',
			metchWords: 'Combine em pares',
			addNewCategory: 'Adicionar nova categoria',
			personalizeLearning:
				'Personalize seu aprendizado criando sua própria categoria.',
			typeNewCategory: 'Digite o nome da sua categoria',
			save: 'Salvar',
			weAreCreatingCategoryForYou:
				'Estamos criando uma nova categoria para você:',
			start: 'INICIAR',
			howToUseFlashcard: 'Como usar os flashcards?',
			knowFlashcard:
				'Clique em "Não sei" ou "Sei" para avaliar seu conhecimento.',
			dontKnowFlashcard: 'Flashcards marcados com "Sei" não serão repetidos.',
			clickToHear: 'Clique para ouvir a palavra.',
			clickForDefinition: 'Clique para ver a definição',
			clickForTranslation: 'Clique para ver a tradução e exemplos',
			close: 'Fechar',
			clickCategoryToStart:
				'Clique na categoria selecionada para começar o aprendizado.',
			lookAsProgressBar:
				'A barra de progresso abaixo da categoria mostra quantas palavras você já dominou.',
			clickToSetupFavaroiteFlashcard:
				'Clique para marcar a categoria como favorita.',
			clickToCreateOwnCategory:
				'Clique para criar sua própria categoria de flashcards.',
			howLearningLookLike: 'Como é o aprendizado?',
			restText:
				' O aprendizado consiste em revisar os flashcards e avaliar seu conhecimento. Além disso, você resolverá tarefas simples.',
		},
		chat: {
			title: 'Chat',
			subtitle: 'Converse sobre qualquer assunto.',
		},
		fotoMode: {
			title: 'Puzzle de foto',
			subtitle: 'Descreva a imagem o mais detalhadamente possível.',
		},
		scene: {
			title: 'Cenas',
			subtitle: 'Jogue um papel com um tutor AI.',
		},
		word: {
			title: 'Palavras',
			subtitle: 'Expanda seu vocabulário.',
		},
		flashcard: {
			title: 'Flashcards',
			subtitle: 'Revise e memorize palavras.',
		},
		seeMore: 'Ver tudo',
	},
	common: {
		description:
			'Synthi AI - Seu assistente inteligente para aprender inglês. Aprenda a falar fluentemente em inglês com a ajuda da inteligência artificial. Descubra uma nova abordagem eficaz para aprender idiomas. Comece hoje!',
		deletedFromFavorite: 'Removido dos favoritos',
		addedToFavorite: 'Adicionado aos favoritos',
		flashcards: 'Flashcards',
		flashcards_v2: 'Flashcards',
		scenes: 'Cenas',
		scenes_v3: 'Cenas',
		words: 'Palavras',
		or: 'ou',
		continueWithFB: 'Continuar com o Facebook',
		privacyLink: 'privacy',
		termsLink: 'tos',
	},
	profile: {
		days: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
		top: {
			profile: 'Perfil',
			accessTo: 'Acesso a:',
			profileImage: 'Imagem do perfil',
			nameAndSurname: 'Nome completo',
			password: 'Senha',
			change: 'Alterar',
			changeProfileImage: 'Alterar imagem de perfil',
			changeNameAndSurname: 'Alterar nome completo',
			changeNameAndSurnamePlaceHolder: 'Digite seu nome completo',
			save: 'Salvar',
			changePassword: 'Alterar senha',
			passwordInfo:
				'A senha deve ter pelo menos 8 caracteres e conter letras, maiúsculas e números.',
			repeatPassword: 'Repita a senha',
			passwordChanged: 'Senha alterada',
			error: 'Ops, algo deu errado',
			nameChanged: 'Nome alterado',
			profileChanged: 'Perfil alterado',
		},
		plan: {
			subInfo:
				'Para cancelar a assinatura, envie um e-mail para contact@synthiaiapp.com',
			yourPlan: 'Seu plano',
			extend: 'Renovar plano',
			short_extend: 'Renovar',
			currentPlan: 'Plano atual:',
			activeToPlan: 'Ativo até:',
			currentPlanLong: 'Seu plano atual',
		},
		middle: {
			yourMedals: 'Suas medalhas',
			oneDay: 'Dia',
			twoDays: 'Dias',
			words: 'Palavras',
			learningTime: 'Tempo de aprendizado',
			streak: 'Série',
			streakRecord: 'Recorde da série',
			yourRecord: 'Seu recorde:',
			currentRecord: 'Estágio atual:',
			words: 'Palavras',
			wordsInWeek: 'Número de palavras por semana:',
		},
		bottom: {
			yourTutor: 'Seu tutor AI',
			change: 'Alterar',
			logout: 'Sair',
			FAQ: 'Perguntas frequentes',
			shareOpinion: 'Compartilhe sua opinião',
			yourPlan: 'Seu plano',
			hobby: 'Interesses',
			learningSetting: 'Configurações de aprendizado',
			back: 'Voltar',
			dayTarget: 'Objetivo diário',
			languageLevel: 'Nível de idioma',
			changeYourLangLevel: 'Altere seu nível de idioma.',
			pickNewTutor: 'Escolha um novo tutor',
			yourDecision: 'Sua decisão afetará o estilo e a atmosfera das aulas.',
			tutroChanged: 'Tutor alterado',
			error: 'Ops, algo deu errado',
			englishLevelChanged: 'Seu nível foi alterado',
			levelsOptions: [
				{
					name: 'Iniciante A1',
					description: 'Comece sua jornada com o inglês',
					value: 'basic',
					borderRadius: '8px 8px 0 0',
				},
				{
					name: 'Iniciante A2',
					description:
						'Você pode entender expressões básicas em conversas simples.',
					borderRadius: '0',
					value: 'beginner',
				},
				{
					name: 'Intermediário B1',
					description:
						'Você pode ter conversas simples, mas compreensíveis, sobre temas familiares.',
					borderRadius: '0',
					value: 'intermediate',
				},
				{
					name: 'Avançado B2',
					description: 'Você se comunica livremente na maioria das situações',
					borderRadius: '0',
					value: 'advanced',
				},
				{
					name: 'Especialista C1+',
					description:
						'Você domina o idioma de forma eficaz em contextos complexos.',
					value: 'expert',
					borderRadius: '0 0 8px 8px ',
				},
			],
			changeDailyTarget: 'Altere seu objetivo diário de aprendizado.',
			deletedFromFavorite: 'Removido dos favoritos',
			addedToFavorite: 'Adicionado aos favoritos',
			lessonTime: [
				{
					name: 'Aula rápida',
					dsecription: 'Opção ideal para aprendizado rápido',
					time: '5 minutos',
					value: 'five_minutes',
					borderRadius: '8px 8px 0 0',
				},
				{
					name: 'Sessão padrão',
					dsecription: 'Ótima escolha para aprendizado equilibrado',
					time: '10 minutos',
					value: 'ten_minutes',
					borderRadius: '0',
				},
				{
					name: 'Treinamento intenso',
					dsecription: 'A melhor opção para entusiastas',
					time: '15 minutos',
					value: 'fifteen_minutes',
					borderRadius: '0 0 8px 8px ',
				},
			],
			dailyTargetChanged: 'Objetivo diário alterado!',
			pickIntresets: 'Escolha pelo menos 3 interesses.',
			activeTo: 'Plano ativo até:',
			daysLeft: 'Dias restantes no plano:',
			opinionSubtitle:
				'Estamos constantemente melhorando nosso aplicativo. Diga-nos o que podemos mudar ou o que você mais gostou.',
			startTyping: 'Digite sua opinião.',
			faq: 'Perguntas frequentes',
			send: 'Enviar',
			withProblems: 'Para dúvidas/problemas, entre em contato conosco em:',
			contactMail: 'contact@synthiaiapp.com',
			faqConfig: [
				{
					id: 1,
					question: 'O som não está funcionando.',
					answer: `Se você está tendo problemas com o som, siga estas dicas: 
      
              Verifique as permissões de som no seu navegador.
      
              Certifique-se de que o volume do seu dispositivo está correto.
      
              Verifique a conexão dos seus alto-falantes/fones de ouvido.
      
              Verifique as configurações de som do sistema para garantir que os aplicativos não estão silenciados.
      
              Tente outro dispositivo ou entre em contato com o suporte técnico.
          `,
				},
				{
					id: 2,
					question: 'Não consigo gravar minha voz.',
					answer: `Se você está tendo problemas para gravar o áudio, siga estas dicas: 
              
              Verifique as permissões de microfone no seu navegador.
      
              Certifique-se de que o navegador móvel tem acesso ao microfone.
      
              Verifique a conexão correta do microfone.
      
              Use outro dispositivo ou entre em contato com o suporte técnico.
          `,
				},
				{
					id: 3,
					question: 'Posso usar o aplicativo em vários dispositivos?',
					answer: `Claro, faça login em cada dispositivo compatível para aproveitar uma experiência de aprendizado contínua.`,
				},
				{
					id: 4,
					question: 'Posso usar o Synthi Ai offline?',
					answer: `Não, o Synthi Ai requer um navegador da web com acesso à internet.`,
				},
				{
					id: 5,
					question: 'Como posso mudar meu tutor AI?',
					answer: `Vá até "Tutor" nas configurações do Synthi Ai. Explore e escolha o tutor que você prefere.`,
				},
				{
					id: 6,
					question: 'Como posso renovar meu acesso após a expiração?',
					answer: `Você pode renovar seu plano após a expiração fazendo login.`,
				},
				{
					id: 7,
					question: 'Posso receber uma fatura?',
					answer:
						'Entre em contato conosco em contact@synthiaiapp.com e forneça seu código fiscal e dados da empresa.',
				},
				{
					id: 8,
					question: 'Como posso entrar em contato com o suporte técnico?',
					answer:
						'Envie um e-mail para contact@synthiaiapp.com e forneça detalhes sobre o problema, bem como informações sobre seu dispositivo e navegador.',
				},
			],
		},
		rules: 'Regras',
		privacy: 'Política de privacidade',
		span: ' e ',
	},
	welcome: {
		languagePicker: {
			title: 'Escolha o idioma que deseja aprender',
			next: 'Avançar',
			langToLearn: 'Idioma a aprender',
			successTitle: 'Idioma de aprendizagem alterado',
			config: [
				{
					label: 'Inglês',
					label2: 'Inglês',
					labelInside: 'inglês',
					value: 'en',
				},
				{
					label: 'Alemão',
					label2: 'Alemão',
					labelInside: 'alemão',
					value: 'de',
				},
				{
					label: 'Espanhol',
					label2: 'Espanhol',
					labelInside: 'espanhol',
					value: 'es',
				},
				{
					label: 'Francês',
					label2: 'Francês',
					labelInside: 'francês',
					value: 'fr',
				},
				{
					label: 'Italiano',
					label2: 'Italiano',
					labelInside: 'italiano',
					value: 'it',
				},
			],
		},
		zeroScreen: {
			welcomeInApp: 'Bem-vindo ao aplicativo Synthi AI!',
			start: 'VAMOS COMEÇAR',
			welcomeMobile: 'Bem-vindo',
			config: {
				chrome: {
					title: 'Instale o aplicativo no seu dispositivo Android.',
					text1: 'Toque no botão',
					text1bold: ' Configurações',
					image1: Android1,
					text2: 'Em seguida, toque em',
					text2bold: ' Adicionar à tela inicial',
					image2: Android2,
					text3: 'Pronto! O Synthi AI agora está na sua tela inicial.',
					image3: Last,
				},
				safari: {
					title: 'Instale o aplicativo no seu dispositivo iOS.',
					text1: 'Toque no botão',
					text1bold: ' Compartilhar',
					image1: Ios1,
					text2: 'Em seguida, toque em',
					text2bold: ' Adicionar à tela inicial',
					image2: Ios2,
					text3: 'Pronto! O Synthi AI agora está na sua tela inicial.',
					image3: Last,
				},
			},
		},
		firstScreen: {
			title: 'Escolha seu tutor!',
			subtitle: 'Sua decisão influenciará o estilo e a atmosfera das aulas.',
			next: 'CONTINUAR',
		},
		secondScreen: {
			title: 'Qual é o seu nível atual de {language}?',
			config: [
				{
					name: 'Iniciante A1',
					description: 'Comece sua jornada com {language}.',
					value: 'basic',
				},
				{
					name: 'Iniciante A2',
					description:
						'Você pode entender informações básicas em conversas simples do dia a dia.',
					value: 'beginner',
				},
				{
					name: 'Intermediário B1',
					description:
						'Você pode ter conversas simples, mas compreensíveis, sobre temas familiares.',
					value: 'intermediate',
				},
				{
					name: 'Avançado B2',
					description: 'Você se comunica livremente na maioria das situações',
					value: 'advanced',
				},
				{
					name: 'Especialista C1+',
					description:
						'Você domina o idioma de forma eficaz em contextos complexos.',
					value: 'expert',
				},
			],
			next: 'CONTINUAR',
		},
		thirdScreen: {
			title: 'Quais são seus interesses?',
			subtitle: 'Escolha pelo menos 3 interesses.',
			next: 'CONTINUAR',
		},
		fourthScreen: {
			title: 'Quantos minutos por dia você deseja estudar?',
			subtitle: 'Escolha seu objetivo diário de aprendizado.',
			next: 'VAMOS COMEÇAR!',
			config: [
				{
					name: 'Aula rápida',
					dsecription: 'Opção ideal para aprendizado rápido',
					time: '5 minutos',
					value: 'five_minutes',
				},
				{
					name: 'Sessão padrão',
					dsecription: 'Ótima escolha para aprendizado equilibrado',
					time: '10 minutos',
					value: 'ten_minutes',
				},
				{
					name: 'Treinamento intenso',
					dsecription: 'A melhor opção para entusiastas',
					time: '15 minutos',
					value: 'fifteen_minutes',
				},
			],
		},
	},
	features: {
		wordTrainer: {
			next: 'Próximo',
			yourSpeaking: 'Sua pronúncia',
			you: 'Você',
			title: 'Treinador de palavras',
			errorMessage:
				'Ops! Temos um problema ao processar sua gravação. Tente novamente :)))',
			endScreenTitle: 'Incrível! 🌟🌟🌟',
			endScreenTopInfo: 'Você dominou todas as',
			endScreenMiddleInfo: 'palavras',
			endScreenBottomInfo: 'deste nível.',
			endScreenText:
				'Você pode começar novamente ou mudar o nível nas configurações.',
			endScreenBottomText: 'Começar novamente',
			endScreenEndText: 'Finalizar',
			sesionScoreTitle: 'Você está arrasando! 🎉',
			sesionScoreSubTitle: 'Você está melhorando sua pronúncia',
			sesionScoreWord: 'Palavras',
			now: 'Agora',
			sum: 'total',
			continue: 'CONTINUAR',
			areYouSureToEndLesson: 'Tem certeza de que deseja encerrar a lição?',
			speakingScore: 'Pontuação de pronúncia',
			GOOD_ARRAY: [
				'Bravo!',
				'Perfeito!',
				'Você é um campeão!',
				'Excelente!',
				'Incrível!',
				'Genial!',
			],
			BAD_ARRAY: [
				'Não desista!',
				'Você consegue!',
				'Mais perto!',
				'Continue repetindo, quase lá!',
				'Logo você consegue!',
				'Sem problemas, tente novamente!',
			],
			OK_ARRAY: [
				'Você está no caminho certo!',
				'Quase lá!',
				'Crescendo cada vez mais!',
				'Você está progredindo!',
				'Parabéns pelo esforço!',
			],
			hold: 'Segure',
			holdText: 'o microfone e diga:',
			tutorial: {
				title: 'Como usar o Treinador de Palavras?',
				options: [
					{
						label: 'Toque para ouvir a pronúncia correta',
						icon: Micro,
					},
					{
						label: 'Segure e pronuncie a palavra',
						icon: Voice,
					},
					{
						label: 'Toque e ouça sua gravação para dominar a palavra!',
						icon: Person,
					},
				],
				close: 'FECHAR',
			},
		},
		sceneV3: {
			twoToFiveMinutes: '2–5 minutos',
			twoToFiveMin: '2–5 min',
			role: 'Papel',
			description: 'Descrição',
			task: 'Tarefa',
			tasks: 'Tarefas',
			conversationStarted: 'Conversa iniciada',
			areYouSureYouWantToLeave: 'Tem certeza de que deseja sair?',
			youWillLoseProgress: 'você perderá o progresso',
			continue: 'Continuar',
			leave: 'Sair',
			congratulations: 'Parabéns!',
			yourAnswersWereClearAndLucid:
				'Suas respostas foram claras e coerentes, e as frases estavam bem estruturadas.',
			finish: 'Finalizar',
			howToUseScenes: 'Como usar Cenas?',
			buyingShoes: 'Comprando sapatos',
			clickSelectedScene:
				'Clique na cena selecionada para começar o aprendizado.',
			clickToMarkAsFavorite: 'Clique para marcar a cena como favorita.',
			youSeeWhenSceneIsDone: 'Você verá quando a cena estiver concluída.',
			howLearningLookLike: 'Como é o aprendizado?',
			learningIsAbout:
				'Aprender consiste em ter uma conversa curta e real, seguindo a descrição e as tarefas da cena.',
			close: 'Fechar',
			clickToShareOpinion: 'Clique para compartilhar sua opinião',
			clickToShownInstructions: 'Clique para abrir as instruções',
			clickToCheckTasks: 'Clique para verificar as tarefas',
			clickToHearAgain: 'Clique para ouvir novamente',
			clickToShowTranslation: 'Clique para ver a tradução',
			clickToShowHint: 'Clique para ver uma dica',
			clickToReportAProblem: 'Clique para relatar um problema',
			yourAnswerIsCorrect: 'Sua resposta está correta',
			clickToShowCorrectAnswer:
				'Clique para ver a resposta correta e a explicação',
			clickInTheTextInput:
				'Clique no campo de texto para escrever sua resposta',
			clickToStartRecording: 'Clique para começar a gravar',
			taskCompleted: 'Tarefa concluída',
			whenAllTasksAreDone:
				'Quando todas as tarefas forem concluídas, a cena estará completa.',
			start: 'Começar',
			next: 'Próximo',
			skip: 'Pular',
			howToTalkInScenes: 'Como falar em Cenas?',
		},
		topbar: {
			back: 'Voltar',
		},
		fotoMode: {
			welcome: {
				title: 'Puzzle de foto',
				subtitle:
					'Descreva o que você vê na imagem, com o máximo de detalhes possível sobre um tema escolhido.',
				start: 'Começar!',
			},
			info: {
				startTyping: 'Escreva...',
				newTask: 'Nova tarefa',
				send: 'Enviar',
			},
		},
		flashcards: {
			title: 'Flashcards',
			subtitleTop:
				'Aprenda e memorize novas palavras através de métodos interativos de aprendizado com flashcards.',
			addCategory: 'Adicione sua categoria',
			subtitle: 'Digite o nome da sua categoria',
			type: 'digite a categoria...',
			add: 'Adicionar',
			previous: 'Flashcard anterior',
			task: 'Tarefa',
			changeLevel: 'Mudar nível',
			dontKnow: 'Não sei',
			know: 'Sei',
			pickPairs: 'Formar pares',
			goodJob: 'Bom trabalho!',
			titleEnd: 'Seu compromisso é impressionante',
			subtitleEnd: 'Você está pronto para novos desafios?',
			repeat: 'Repita a categoria',
			other: 'Escolha outra categoria',
			level: {
				title: 'Mude o nível dos flashcards',
				beginner: 'Iniciante A1-A2',
				intermediate: 'Intermediário B1-B2',
				advance: 'Avançado C1-C2',
				change: 'Mudar',
			},
		},
		scene: {
			title: 'Cenas',
			subtitle:
				'Entre no papel e jogue uma cena com um tutor AI sobre um tema escolhido.',
			suggest: 'Sugerir uma nova cena',
			talk: 'Falar',
			deletedFromFavorite: 'Removido dos favoritos',
			addedToFavorite: 'Adicionado aos favoritos',
		},
		word: {
			title: 'Palavras',
			subtitle:
				'Expanda seu vocabulário em tópicos-chave de conversa com um tutor AI.',
			suggest: 'Sugerir um novo tópico de palavras',
			deletedFromFavorite: 'Removido dos favoritos',
			addedToFavorite: 'Adicionado aos favoritos',
		},
	},
	cookie: {
		title: 'Este site utiliza cookies',
		subtitle:
			'Usamos cookies para personalizar conteúdo, analisar tráfego e exibir anúncios personalizados. Você pode gerenciar suas configurações de privacidade. Mais detalhes em',
		link: 'Política de privacidade',
		accept: 'ACEITAR',
		denied: 'RECUSAR',
		manage: 'Personalizar',
		saveChanges: 'Salvar escolha',
		necessary: {
			top: 'Necessários',
			text: 'Esses cookies são essenciais para o funcionamento adequado do site.',
		},
		functional: {
			top: 'Funcionais',
			text: 'Eles lembram suas configurações, como idioma.',
		},
		analytical: {
			top: 'Analíticos',
			text: 'Nos ajudam a medir o tráfego e melhorar o site.',
		},
		marketing: {
			top: 'De marketing',
			text: 'Permitem personalizar anúncios e remarketing.',
		},
		personalization: {
			top: 'Personalização de conteúdo',
			text: 'Permitem personalizar o conteúdo do site e as recomendações de produtos com base em seus interesses.',
		},
	},
	talkingBar: {
		allowMicrofon: 'Por favor, permita o acesso ao microfone',
		typeMessage: 'Digite uma mensagem...',
		record: 'Gravar',
		recording: 'Gravando',
	},
	hands: {
		giveUsInfo: 'Compartilhe sua opinião conosco.',
		thanksForGrading: 'Obrigado pela avaliação!',
		subtitle: 'Sua opinião é importante para nós!',
		subtitle2: 'Diga-nos o que você acha desta lição:',
		skip: 'PULAR',
		send: 'ENVIAR',
	},
	suggestConfig: {
		profile: {
			title: 'Compartilhe sua opinião!',
			subtitle:
				'Estamos sempre melhorando nosso aplicativo. Diga-nos o que podemos mudar ou o que você mais gostou.',
		},
		word: {
			title: 'Sugira um novo tópico de palavras',
			subtitle: '',
		},
		scene: {
			title: 'Sugira uma nova cena',
			subtitle: '',
		},
		startTyping: 'Comece a escrever',
		send: 'ENVIAR',
		thx: 'Sua opinião foi adicionada! Obrigado!',
		error: 'Ops, algo deu errado',
	},
	checkout: {
		emailGuessText: 'Você quis dizer',
		leftTitle: 'Escolha um plano para você',
		rightTitle: 'Complete seus dados',
		email: 'E-mail',
		placeHolderEmail: 'Digite o e-mail',
		pay: 'COMPRAR E PAGAR',
		accept: 'Aceitar',
		rules: 'regulamento',
		space: 'e',
		tos: 'política de privacidade',
		payingAccept: 'Ao pagar, você aceita',
		paymentRules: '"Regras de pagamento PayU"',
		savePayments: 'Pagamentos seguros garantidos por',
		total: 'Total',
		currency: 'brl',
		currencySign: 'R$',
		subscribe: 'PAGAR AGORA',
		payNow: 'COMPRE AGORA',
		planConfig: {
			pre: 'Junte-se a',
			preColor: ' 50.000',
			post: 'usuários que já estão alcançando seus objetivos ',
			postColor: 'com o Synthi AI',
		},
	},
	dailyV2: {
		conversation: {
			doYouWantContinueConversation:
				'Deseja continuar a conversa ou começar uma nova?',
			continueConversation: 'Continuar conversa',
			newConversation: 'Nova conversa',
		},
		hint: {
			title: 'Dica',
			pick: 'Escolha',
			writeOrRecordAResponse: 'Escreva ou grave uma resposta',
			tryToSay: 'Tente dizer',
		},
		feedback: {
			yourMessage: 'Sua mensagem',
			goodMessage: 'Mensagem correta',
			explanation: 'Explicação',
		},
		tutorial: {
			title: 'Como usar o chat?',
			skip: 'Pular',
			next: 'PRÓXIMO',
			start: 'Começar',
			screenConf: [ScreenOne, ScreenTwo, ScreenThree, ScreenFour],
			config: [
				[
					{
						title: 'Toque para desativar o som do Tutor',
						image: VolumeUp,
					},
					{ title: 'Toque para fornecer feedback', image: HandsUp },
					{
						title: 'Clique para abrir as instruções',
						image: Tutorial,
					},
				],
				[
					{ title: 'Toque para reproduzir novamente', image: VolumeUpBlank },
					{
						title: 'Toque para ver a tradução',
						image: TranslationBlank,
					},
					{ title: 'Toque para ver a dica', image: HintBlank },
					{ title: 'Toque para relatar um problema', image: InfoBlank },
				],
				[
					{ title: 'Sua resposta está correta', image: GreenCircle },
					{
						title: 'Toque para ver a resposta corrigida e explicação',
						image: YellowCircle,
					},
				],
				[
					{ title: 'Toque no campo de texto para escrever uma mensagem' },
					{ title: 'Toque para gravar uma mensagem', image: Microphone },
				],
			],
		},
	},
	problem: {
		title: 'Relatar um problema',
		subtitle: 'Descreva o problema referente à mensagem AI',
		send: 'Enviar',
		messageSend: 'Mensagem enviada',
		error: 'Algo deu errado, escreva para nós :)',
	},
	footer: {
		copy: 'Copyright©',
		privacy: 'Política de privacidade',
		cookie: 'Política de cookies',
		rules: 'Termos e condições',
		privacyUrl: '/privacy',
		rulesUrl: '/tos',
	},
};
